const CHECKOUT_BASE_URL = "/kasse";
const CHECKOUT_BASE_URL_B2B = "/bedrift/kasse";
const TRANSFER_OWNERSHIP_URL = "/eierskifte";
const TRANSFER_OWNERSHIP_B2B_API = "/shop/api/transfer/bedrift";
const UPDATE_PORTING_DATE = "/mine-ordre/oppdater-portering";
const INSTALL_ESIM_URL = "/esim/installering";
const FWA_URL = "/internett";
const TELIA_PLAY_URL = "/telia-play/kasse";
const PREPAID_REGISTRATION = "/mobilabonnement/kontantkort/registrering";
const PREPAID_REFILL = "/mobilabonnement/kontantkort/lade";
const SUBSCRIPTIONS_URL = "/mobilabonnement";
const AUTHENTICATE_USER_URL = "/verifisering";
export const ONBOARDING_BASE_URL_B2B = "/onboarding";
export const RETAILER_BASE_URL = "/nexus";

const pages = {
    LISTING_PAGES: {
        MOBILE: {
            URL: "/mobiltelefoner/",
        },
        SIMONLY: {
            URL: `${SUBSCRIPTIONS_URL}/`,
        },
        WEARABLE: {
            URL: "/smartklokker/",
        },
        TABLET: {
            URL: "/nettbrett/",
        },
        ACCESSORY: {
            URL: "/mobiltilbehor/",
        },
        CONNECTED_DEVICE: {
            URL: "/smarthjem/",
        },
        MBB: {
            URL: "/mobilt-bredband/",
        },
        PREOWNED: {
            URL: "/mobiltelefoner/like-fin/",
        },
    },
    CHECKOUT: {
        URL: `${CHECKOUT_BASE_URL}/`,
        RESUBMIT: {
            URL: `${CHECKOUT_BASE_URL}/resubmit/`,
        },
        PERSONAL_DETAILS: {
            URL: `${CHECKOUT_BASE_URL}/personlige-opplysninger/`,
            TITLE: "",
        },
        ADD_MEMBER: {
            URL: `${CHECKOUT_BASE_URL}/medlem/`,
            TITLE: "Bruker av abonnementet",
        },
        SUMMARY: {
            URL: `${CHECKOUT_BASE_URL}/oppsummering/`,
            TITLE: "Stemmer alt?",
        },
        RECEIPT: {
            URL: `${CHECKOUT_BASE_URL}/kvittering/`,
            TITLE: "Kvittering",
        },
        QUEUE: {
            URL: `${CHECKOUT_BASE_URL}/venterom/`,
            TITLE: "Venterom",
        },
        ORDER_SIMDEAL: {
            URL: `${CHECKOUT_BASE_URL}/pakketilbud/`,
            TITLE: "Pakketilbud",
        },
        INCOMPLETE_ORDER_FORM: {
            URL: `${CHECKOUT_BASE_URL}/bestillingsskjema/`,
            TITLE: "Bestillingsskjema",
        },
        CONTINUE_INCOMPLETE_ORDER: {
            URL: `${CHECKOUT_BASE_URL}/fortsett/`,
            TITLE: "Bestillingsskjema",
        },
        ERROR: {
            URL: `${CHECKOUT_BASE_URL}/feil/`,
            TITLE: "En feil har oppstått",
        },
    },
    CHECKOUT_B2B: {
        URL: `${CHECKOUT_BASE_URL_B2B}/`,
        PERSONAL_DETAILS: {
            URL: `${CHECKOUT_BASE_URL_B2B}/personlige-opplysninger/`,
            TITLE: "",
        },
        SUMMARY: {
            URL: `${CHECKOUT_BASE_URL_B2B}/oppsummering/`,
            TITLE: "Stemmer alt?",
        },
        RECEIPT: {
            URL: `${CHECKOUT_BASE_URL_B2B}/kvittering/`,
            TITLE: "Kvittering",
        },
        ORDER: {
            URL: `${CHECKOUT_BASE_URL_B2B}/bestilling/`,
            TITLE: "Bestilling",
        },
    },
    TRANSFER_OWNERSHIP: {
        URL: `${TRANSFER_OWNERSHIP_URL}/`,
        API_URL: `${TRANSFER_OWNERSHIP_B2B_API}/`,
        CONFIRM_ID: {
            URL: `${TRANSFER_OWNERSHIP_URL}/bekreft-id/`,
            SUFFIX: "bekreft-id/",
        },
        CONFIRM_NUMBER: {
            URL: `${TRANSFER_OWNERSHIP_URL}/bekreft-nummer/`,
            SUFFIX: "bekreft-nummer/",
        },
        SUMMARY: {
            URL: `${TRANSFER_OWNERSHIP_URL}/se-over/`,
            SUFFIX: "se-over/",
        },
        REQUEST_TRANSFER_OF_OWNERSHIP: {
            URL: `${TRANSFER_OWNERSHIP_URL}/bestill-eierskifte/`,
            SUFFIX: "bestill-eierskifte/",
        },
        LANDING_PAGE_TO_B2B_AND_B2C: {
            URL: `${TRANSFER_OWNERSHIP_URL}/samtykke/`,
        },
        LANDING_PAGE_B2C_TO_B2C: {
            URL: `${TRANSFER_OWNERSHIP_URL}/godkjenning/privat/til/privat/`,
        },
        LANDING_PAGE_B2B_TO_B2C: {
            URL: `${TRANSFER_OWNERSHIP_URL}/godkjenning/bedrift/til/privat/`,
        },
        LANDING_PAGE_TO_B2B: {
            URL: `${TRANSFER_OWNERSHIP_URL}/godkjenning/til/bedrift/`,
            SUMMARY: `${TRANSFER_OWNERSHIP_URL}/godkjenning/til/bedrift/bekreft/oppsummering/`,
        },
        ENTER_NUMBER_OR_EMAIL: {
            URL: `${TRANSFER_OWNERSHIP_URL}/bestill-eierskifte/portering/`,
        },
        LANDING_PAGE_PORTIN_B2C: {
            URL: `${TRANSFER_OWNERSHIP_URL}/godkjenning/portering/privat/`,
        },
        LANDING_PAGE_FROM_CHECKOUT_EXISTING: {
            URL: `${TRANSFER_OWNERSHIP_URL}/godkjenning/privat/`,
        },
    },
    FWA: {
        URL: `${FWA_URL}/`,
        ADDRESS_SEARCH: {
            URL: `${FWA_URL}/adressesok/`,
            SUFFIX: "adressesok/",
        },
        CHOOSE_SUBSCRIPTION: {
            URL: `${FWA_URL}/adressesok/pakke/`,
            SUFFIX: "adressesok/pakke/",
        },
        INSTALLMENT: {
            URL: `${FWA_URL}/adressesok/installering/`,
            SUFFIX: "adressesok/installering/",
        },
        CUSTOMER: {
            URL: `${FWA_URL}/adressesok/verifisering/`,
            SUFFIX: "adressesok/verifisering/",
        },
        PERSONAL_DETAILS: {
            URL: `${FWA_URL}/adressesok/personlige-opplysninger/`,
            SUFFIX: "adressesok/personlige-opplysninger/",
        },
        RECEIPT: {
            URL: `${FWA_URL}/adressesok/kvittering/`,
            SUFFIX: "adressesok/kvittering/",
        },
        FALLBACK: {
            URL: `${FWA_URL}/kontaktinfo-adressesjekk/`,
            SUFFIX: "kontaktinfo-adressesjekk/",
        },
    },
    TELIA_PLAY: {
        URL: `${TELIA_PLAY_URL}/`,
        CUSTOMER: {
            URL: `${TELIA_PLAY_URL}/verifisering/`,
            SUFFIX: "verifisering/",
        },
        SUMMARY: {
            URL: `${TELIA_PLAY_URL}/oppsummering/`,
            SUFFIX: "oppsummering/",
        },
        RECEIPT: {
            URL: `${TELIA_PLAY_URL}/kvittering/`,
            SUFFIX: "kvittering/",
        },
    },
    UPDATE_PORTING_DATE: {
        URL: `${UPDATE_PORTING_DATE}/`,
    },
    INSTALL_ESIM: {
        URL: `${INSTALL_ESIM_URL}/`,
    },
    AUTHENTICATE_USER_PAGE: {
        URL: `${AUTHENTICATE_USER_URL}/`,
        BANK_ID: {
            URL: `${AUTHENTICATE_USER_URL}/bankid/`,
            SUFFIX: "bankid/",
        },
    },
    PREPAID: {
        REFILL: {
            URL: `${PREPAID_REFILL}/`,
            PERSONAL_DETAILS: {
                URL: `${PREPAID_REFILL}/personlige-opplysninger/`,
                SUFFIX: "personlige-opplysninger/",
            },
            CHOOSE_PACKAGE: {
                URL: `${PREPAID_REFILL}/velg-pakke/`,
                SUFFIX: "velg-pakke/",
            },
            SUMMARY: {
                URL: `${PREPAID_REFILL}/oppsummering/`,
                SUFFIX: "oppsummering/",
            },
            PAYMENT_PROCESSING: {
                URL: `${PREPAID_REFILL}/payment-processing/`,
                SUFFIX: `payment-processing/`,
            },
            RECEIPT: {
                URL: `${PREPAID_REFILL}/kvittering/`,
                SUFFIX: "kvittering/",
            },
        },
        REGISTRATION: {
            URL: `${PREPAID_REGISTRATION}/`,
            SIMCARD: {
                URL: `${PREPAID_REGISTRATION}/sim-kort/`,
                SUFFIX: "sim-kort/",
            },
            RECEIPT: {
                URL: `${PREPAID_REGISTRATION}/bekreftelse/`,
                SUFFIX: "bekreftelse/",
            },
        },
    },
    ONBOARDING_B2B: {
        URL: `${ONBOARDING_BASE_URL_B2B}/`,
        BANKID: {
            URL: `${ONBOARDING_BASE_URL_B2B}/bankid/`,
            SUFFIX: "bankid/",
        },
        CONTACT_INFORMATION: {
            URL: `${ONBOARDING_BASE_URL_B2B}/kontaktinformasjon/`,
            SUFFIX: "kontaktinformasjon/",
        },
        SUBSCRIPTION_DETAILS: {
            URL: `${ONBOARDING_BASE_URL_B2B}/abonnementsdetaljer/`,
            SUFFIX: "abonnementsdetaljer/",
        },
        SUMMARY: {
            URL: `${ONBOARDING_BASE_URL_B2B}/oppsummering/`,
            SUFFIX: "oppsummering/",
        },
        RECEIPT: {
            URL: `${ONBOARDING_BASE_URL_B2B}/bekreftelse/`,
            SUFFIX: "bekreftelse/",
        },
    },
    RETAILER: {
        URL: `${RETAILER_BASE_URL}/`,
        SHOPS: {
            URL: `${RETAILER_BASE_URL}/butikker/`,
            SUFFIX: "butikker/",
        },
        ORDER: {
            URL: `${RETAILER_BASE_URL}/bestilling/`,
            SUFFIX: "bestilling/",
            CUSTOMER: {
                URL: `${RETAILER_BASE_URL}/bestilling/kunde/`,
                SUFFIX: "kunde/",
            },
            SUBSCRIPTION: {
                URL: `${RETAILER_BASE_URL}/bestilling/abonnement/`,
                SUFFIX: "abonnement/",
            },
            ADDITIONAL_SERVICES: {
                URL: `${RETAILER_BASE_URL}/bestilling/tilleggstjenester/`,
                SUFFIX: "tilleggstjenester/",
            },
            EQUIPMENT: {
                URL: `${RETAILER_BASE_URL}/bestilling/utstyr/`,
                SUFFIX: "utstyr/",
            },
            SUMMARY: {
                URL: `${RETAILER_BASE_URL}/bestilling/oppsummering/`,
                SUFFIX: "oppsummering/",
            },
            RECEIPT: {
                URL: `${RETAILER_BASE_URL}/bestilling/kvittering/`,
                SUFFIX: "kvittering/",
            },
        },
        NEWORDER: {
            URL: `${RETAILER_BASE_URL}/nyordre/`,
            SUFFIX: "nyordre/",
        },
        ORDERS_OVERVIEW: {
            URL: `${RETAILER_BASE_URL}/ordreoversikt/`,
            SUFFIX: "ordreoversikt/",
            DRAFT_DETAIL: {
                URL: `${RETAILER_BASE_URL}/ordreoversikt/utkast/`,
                SUFFIX: "utkast/:orderRef/",
            },
            ORDER_DETAIL: {
                URL: `${RETAILER_BASE_URL}/ordreoversikt/`,
                SUFFIX: ":orderId/",
            },
        },
        SALES_REPORTS: {
            URL: `${RETAILER_BASE_URL}/salgsrapporter/`,
            SUFFIX: "salgsrapporter/",
            SALES_TODAY: {
                URL: `${RETAILER_BASE_URL}/salgsrapporter/salg-idag/`,
                SUFFIX: "salg-idag/",
            },
            SALES_LAST_MONTH: {
                URL: `${RETAILER_BASE_URL}/salgsrapporter/salg-siste-maaned/`,
                SUFFIX: "salg-siste-maaned/",
            },
            COMMISSION: {
                URL: `${RETAILER_BASE_URL}/salgsrapporter/provisjon/`,
                SUFFIX: "provisjon/",
            },
            SBI_REPORTS: {
                URL: `${RETAILER_BASE_URL}/salgsrapporter/sbi-rapporter/`,
                SUFFIX: "sbi-rapporter/",
            },
        },
        SALES_SUPPORT: {
            URL: `${RETAILER_BASE_URL}/salgsstotte/`,
            SUFFIX: "salgsstotte/",
            ORDER_SIM: {
                URL: `${RETAILER_BASE_URL}/salgsstotte/bestill-sim/`,
                SUFFIX: "bestill-sim/",
            },
            OWNERSHIP_TRANSFER: {
                URL: `${RETAILER_BASE_URL}/salgsstotte/eierskifteskjema/`,
                SUFFIX: "eierskifteskjema/",
            },
            PRESENTATIONS: {
                URL: `${RETAILER_BASE_URL}/salgsstotte/presentasjoner/`,
                SUFFIX: "presentasjoner/",
            },
            FORMS: {
                URL: `${RETAILER_BASE_URL}/salgsstotte/skjema/`,
                SUFFIX: "skjema/",
            },
            COMMISSION_BULLETIN: {
                URL: `${RETAILER_BASE_URL}/salgsstotte/provisjonsbulletin/`,
                SUFFIX: "provisjonsbulletin/",
            },
            PROCEDURES: {
                URL: `${RETAILER_BASE_URL}/salgsstotte/rutiner/`,
                SUFFIX: "rutiner/",
            },
            NEWS: {
                URL: `${RETAILER_BASE_URL}/salgsstotte/nyheter/`,
                SUFFIX: "nyheter/",
            },
            COVERAGE_MAP: {
                URL: `${RETAILER_BASE_URL}/salgsstotte/dekningskart/`,
                SUFFIX: "dekningskart/",
            },
        },
        ADMIN: {
            URL: `${RETAILER_BASE_URL}/administrasjon/`,
            SUFFIX: "administrasjon/",
            SHOP: {
                URL: `${RETAILER_BASE_URL}/administrasjon/butikk/`,
                SUFFIX: "butikk/",
            },
            SELLERS: {
                URL: `${RETAILER_BASE_URL}/administrasjon/selgere/`,
                SUFFIX: "selgere/",
            },
        },
        SUPER_ADMIN: {
            URL: `${RETAILER_BASE_URL}/superadmin/`,
            COMMISSION_ADMIN: {
                URL: `${RETAILER_BASE_URL}/superadmin/provisjon/`,
                SUFFIX: "superadmin/provisjon/",
            },
            COMMISSION_NUMBERS: {
                URL: `${RETAILER_BASE_URL}/superadmin/provisjonstall/`,
                SUFFIX: "superadmin/provisjonstall/",
            },
            DOCUMENT_UPLOAD: {
                URL: `${RETAILER_BASE_URL}/superadmin/dokumenter/`,
                SUFFIX: "superadmin/dokumenter/",
            },
            NEWS_ADMIN: {
                URL: `${RETAILER_BASE_URL}/superadmin/nyheter/`,
                SUFFIX: "superadmin/nyheter/",
            },
            FEEDBACK_ADMIN: {
                URL: `${RETAILER_BASE_URL}/superadmin/vurderinger/`,
                SUFFIX: "superadmin/vurderinger/",
            },
            FEEDBACK_LIST: {
                URL: `${RETAILER_BASE_URL}/superadmin/tilbakemeldinger/`,
                SUFFIX: "superadmin/tilbakemeldinger/",
            },
        },
        FEEDBACKS: {
            URL: `${RETAILER_BASE_URL}/tilbakemeldinger/`,
            SUFFIX: "tilbakemeldinger{/:salesAgentId}",
        },
        FEEDBACK_DETAILS: {
            URL: `${RETAILER_BASE_URL}/tilbakemeldinger/detaljer/`,
            SUFFIX: "tilbakemeldinger/detaljer/:feedbackId",
        },
        CUSTOMER: {
            URL: `${RETAILER_BASE_URL}/kunde/`,
            SUFFIX: "kunde/",
        },
    },
} as const;

export default pages;
